module.exports = __webpack_public_path__ + "img/bull2.378d799d.png";